/**
 * Creates an object with methods for interacting with the share API.
 *
 * @param {Object} $axios - The axios instance used for making HTTP requests.
 * @returns {Object} - An object containing the `getShare` method.
 */
export default $axios => ({
  /**
   * Fetches share information for a specified partner user.
   *
   * @param {string|number} partnerUser - The ID of the partner user.
   * @param {Object} [params={}] - Additional parameters for the request.
   * @param {string|number} params.dealId - The ID of the deal.
   * @param {string|number} params.offerId - The ID of the offer.
   * @returns {Promise} - A promise that resolves to the share details.
   */
  getShare(partnerUser, params = {}) {
    return $axios.get(`/api/partnerUser/${partnerUser}/share`, {
      params
    });
  }
});
